import { useState } from "react";
import { Dropdown, Menu, message, Row, TableColumnsType } from "antd";
import { useHistory, useLocation, useParams } from "react-router-dom";

import Table from "@components/Table";
import Button from "@components/Button";
import {
  ErrorServices,
  useDeleteCompanySubJobFunctionMutation,
  useFetchCompanyJobFunctionByIdQuery,
  useFetchPaginatedCompanySubJobFunctionsQuery,
} from "@services";

import AddCompanyJobSubFunction from "./AddJobSubFunction";
import EditCompanyJobSubFunction from "./EditJobSubFunction";

import { ReactComponent as MenuIcon } from "@assets/images/vertical-dots.svg";
import { useTypedSelector } from "@/hooks";

type SubJobFunctionType = {
  id: number;
  name: string;
  description?: string | null;
};

const CompanySubJobFunction = () => {
  const { job_id: company_job_function_id } = useParams<{ job_id: string }>();
  const [isAddJSFVisible, setIsAddJSFVisible] = useState(false);
  const [isEditJSFVisible, setIsEditJSFVisible] = useState(false);
  const [jsfItem, setJsfItem] = useState<SubJobFunctionType | {}>({});

  const [deleteSubJobFunction] = useDeleteCompanySubJobFunctionMutation();
  const history = useHistory();
  const { user, permissions: per } = useTypedSelector(state => state.auth);

  const company_id = 110;

  const { data, isLoading: isLoadingSubJobFunctions } =
    useFetchCompanyJobFunctionByIdQuery({
      company_id: company_id,
      company_job_function_id,
    });

  const jobFunction = data?.data;
  const subJobFunctions = jobFunction?.sub_job_functions || [];

  const handleActionDropdown = ({
    item,
    key,
    domEvent,
  }: {
    key: string;
    domEvent:
      | React.MouseEvent<HTMLElement, MouseEvent>
      | React.KeyboardEvent<HTMLElement>;
    item: SubJobFunctionType;
  }) => {
    domEvent.stopPropagation();

    if (key === "2") {
      removeSubJobFunction(item?.id.toString());
    } else {
      onEditJSf(item);
    }
  };

  const columns: TableColumnsType<SubJobFunctionType> = [
    {
      title: "Job Sub Function",
      key: "name",
      dataIndex: "name",
      width: "80%",
    },
    ...((per?.includes("UPDATE_JOB_SUB_FUNCTION") ||
    per?.includes("DELETE_JOB_SUB_FUNCTION") ||
    per?.includes("all")
      ? [
          {
            title: "Actions",
            key: "action",
            fixed: "right",
            width: "10%",
            render: (item: SubJobFunctionType) => {
              const menu = (
                <Menu
                  onClick={(info: any) =>
                    handleActionDropdown({
                      item,
                      key: info.key,
                      domEvent: info.domEvent,
                    })
                  }
                  tabIndex={1}
                >
                  {(per?.includes("UPDATE_JOB_SUB_FUNCTION") ||
                    per?.includes("all")) && (
                    <Menu.Item key="1">Edit</Menu.Item>
                  )}

                  {(per?.includes("DELETE_JOB_SUB_FUNCTION") ||
                    per?.includes("all")) && (
                    <Menu.Item key="2" danger>
                      Delete
                    </Menu.Item>
                  )}
                </Menu>
              );

              return (
                <div className="table__action__menu">
                  <Dropdown overlay={menu} trigger={["click"]}>
                    <MenuIcon
                      onClick={e => {
                        e.stopPropagation();
                      }}
                    />
                  </Dropdown>
                </div>
              );
            },
          },
        ]
      : []) as any),
  ];

  const onEditJSf = async (item: SubJobFunctionType) => {
    try {
      setJsfItem(item);
      setIsEditJSFVisible(true);
    } catch (err: any) {
      ErrorServices(err);
    }
  };

  const removeSubJobFunction = async (id: string) => {
    try {
      await deleteSubJobFunction({
        company_id: company_id,
        company_sub_job_function_id: id,
      }).unwrap();

      message.success("Company Sub Job Function Deleted Successfully");
    } catch (err: any) {
      ErrorServices(err);
    }
  };

  return (
    <>
      <AddCompanyJobSubFunction
        setIsVisible={setIsAddJSFVisible}
        isVisible={isAddJSFVisible}
        company_job_function_id={company_job_function_id}
      />

      <EditCompanyJobSubFunction
        setIsVisible={setIsEditJSFVisible}
        isVisible={isEditJSFVisible}
        jsfItem={jsfItem}
      />

      <div className="appTitle text-base font-[500] mx-5">
        <span
          className="cursor-pointer"
          onClick={() => history.push("/job-functions")}
        >
          Company Job Functions
        </span>
        {" > "}
        Company Sub Functions
      </div>

      <div className="jobCreationBar sticky top-0 z-10 bg-white px-14 py-6 rounded-lg flex justify-between items-center my-7">
        <div className="title text-themeBlue font-[500] text-3xl">
          Company Job Sub Functions
        </div>

        {(per?.includes("CREATE_JOB_SUB_FUNCTION") || per?.includes("all")) && (
          <Button variant="add" onClick={() => setIsAddJSFVisible(true)}>
            Add Job-Sub Function
          </Button>
        )}
      </div>

      <Row>
        <Table
          data={subJobFunctions}
          columns={columns}
          isLoading={isLoadingSubJobFunctions}
        />
      </Row>
    </>
  );
};

export default CompanySubJobFunction;
